<!-- Navbar -->
@if (isNavbarShown) {
  <nav class="navbar navbar-expand-xl" [style]="getStyle()">
    <div class="container-fluid">
      <button
        class="navbar__toggler"
        type="button"
        (click)="toggleSidebar()"
        aria-controls="sidebarMenu"
        aria-label="Toggle navigation"
      >
        <i class="ph ph-list sidebar-toggle"></i>
      </button>
      <a class="navbar-brand" href="#">
        <img class="navbar__logo" alt="Avalanche.report Logo" src="{{ environment.logoPath }}" />
      </a>
      <div class="navbar-collapse" id="navbarContent">
        <ul class="navbar-nav me-auto mb-2 mb-xl-0">
          @if (authenticationService.isUserLoggedIn()) {
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/bulletins']" ngxMousetrapKey="g b">
                {{ "sidebar.bulletins" | translate }}
              </a>
            </li>
          }
          @if (authenticationService.getActiveRegion()?.enableDangerSources && authenticationService.isUserLoggedIn()) {
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/danger-sources']" ngxMousetrapKey="g d">
                {{ "sidebar.dangerSources" | translate }}
              </a>
            </li>
          }
          @if (authenticationService.getActiveRegion()?.enableObservations && authenticationService.isUserLoggedIn()) {
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/observations']" ngxMousetrapKey="g o">
                {{ "sidebar.observations" | translate }}
              </a>
            </li>
          }
          @if (authenticationService.getActiveRegion()?.enableIncidents && authenticationService.isUserLoggedIn()) {
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/incidents']" ngxMousetrapKey="g l">
                {{ "sidebar.incidents" | translate }}
              </a>
            </li>
          }
          @if (authenticationService.getActiveRegion()?.enableModelling && authenticationService.isUserLoggedIn()) {
            <li class="nav-item">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['/modelling/geosphere']"
                ngxMousetrapKey="g m"
              >
                {{ "sidebar.geosphere" | translate }}
              </a>
            </li>
          }
          @if (authenticationService.getActiveRegion()?.enableIcon && authenticationService.isUserLoggedIn()) {
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/icon']" ngxMousetrapKey="g i">
                {{ "sidebar.icon" | translate }}
              </a>
            </li>
          }
          @if (authenticationService.getActiveRegion()?.enableModelling) {
            <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="['/modelling/awsome']" ngxMousetrapKey="g a">
                {{ "sidebar.awsome" | translate }}
              </a>
            </li>
          }
          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" [routerLink]="['/graphics']" ngxMousetrapKey="g g">
              {{ "sidebar.graphics" | translate }}
            </a>
          </li>
          <!-- dummy button for keyboard shortcut to place focus on map -->
          <li class="nav-item invisible">
            <button class="btn" type="button" (click)="focusMap()" ngxMousetrapKey="f m">Focus Map</button>
          </li>
        </ul>
      </div>
      <ul class="navbar-nav d-flex flex-row gap-3 ms-auto">
        @if (localStorageService.isTrainingEnabled) {
          <li class="navbar-text" title="{{ 'training.timestamp' | translate }}">
            <i class="ph ph-clock-afternoon"></i>
            {{ localStorageService.trainingTimestamp }}
          </li>
        }
        <li class="nav-item dropdown" dropdown>
          <a
            class="nav-link dropdown-toggle navbar__lang-toggle"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            dropdownToggle
            ngxMousetrapKey="l"
          >
            {{ translateService.getCurrentLang() }}
          </a>
          <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
            <li>
              <h6 class="dropdown-header">{{ "menu.language" | translate }}</h6>
            </li>
            @for (lang of translateService.getLangs(); track lang; let i = $index) {
              <li>
                <a
                  class="dropdown-item"
                  (click)="localStorageService.setLanguage(lang)"
                  role="button"
                  [ngxMousetrapKey]="`${i + 1}`"
                >
                  {{ "menu." + lang | translate }}
                  @if (translateService.getCurrentLang() === lang) {
                    <i class="ph ph-check"></i>
                  }
                </a>
              </li>
            }
          </ul>
        </li>
        @if (authenticationService.effectiveRole; as effectiveRole) {
          @let effectiveRoleLabel =
            ("settings.effectiveRole" | translate) + ": " + ("role." + effectiveRole | translate);
          <ng-template #effectiveRoleBadge>
            <span class="badge" [class]="hasAdminPowers ? 'text-bg-danger' : 'text-bg-secondary'">
              @let effectiveRoleName = "role." + effectiveRole | translate;
              <span class="d-none d-md-inline">{{ effectiveRoleName }}</span>
              <span class="d-md-none">{{ capitals(effectiveRoleName) }}</span>
            </span>
          </ng-template>
          @if (roles.length > 1) {
            <li class="nav-item dropdown d-flex align-items-center" dropdown>
              <a
                class="nav-link dropdown-toggle navbar__role"
                role="button"
                [attr.aria-label]="effectiveRoleLabel"
                [title]="effectiveRoleLabel"
                dropdownToggle
              >
                <ng-container *ngTemplateOutlet="effectiveRoleBadge" />
              </a>
              <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                <li>
                  <h6 class="dropdown-header">{{ "settings.effectiveRole" | translate }}</h6>
                </li>
                @for (role of roles; track role) {
                  <li>
                    <a class="dropdown-item" role="button" (click)="switchEffectiveRole(role)">
                      {{ "role." + role | translate }}
                      @if (effectiveRole === role) {
                        <i class="ph ph-check"></i>
                      }
                    </a>
                  </li>
                }
              </ul>
            </li>
          } @else {
            <li class="nav-item d-flex align-items-center">
              <span class="nav-link navbar__role" [title]="effectiveRoleLabel">
                <ng-container *ngTemplateOutlet="effectiveRoleBadge" />
              </span>
            </li>
          }
        }
        <li class="nav-item dropdown" dropdown>
          <a
            class="nav-link dropdown-toggle user-avatar"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            dropdownToggle
            ngxMousetrapKey="u"
          >
            @if (authenticationService.getCurrentAuthor() && authenticationService.getCurrentAuthor().image) {
              <img
                [src]="authenticationService.getUserImageSanitized(authenticationService.getCurrentAuthor().image)"
                class="user-avatar__img"
              />
            } @else {
              <span class="d-md-none" [title]="authenticationService.getUsername()">{{ userInitials }}</span>
            }
            <span class="d-none d-md-inline">{{ authenticationService.getUsername() }}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
            <li class="d-md-none">
              <h6 class="dropdown-header">{{ authenticationService.getUsername() }}</h6>
            </li>
            <li class="d-md-none">
              <hr class="dropdown-divider" />
            </li>
            <li>
              <h6 class="dropdown-header">{{ "menu.region" | translate }}</h6>
            </li>
            @for (region of authenticationService.getCurrentAuthorRegions(); track region; let i = $index) {
              <li>
                <a class="dropdown-item" (click)="changeRegion(region)" role="button" ngxMousetrapKey="{{ i + 1 }}">
                  @if (region.coatOfArms) {
                    <img
                      [src]="region.coatOfArms"
                      style="height: 24px"
                      [alt]="region.id + ' coat of arms'"
                      aria-hidden="true"
                    />
                  }
                  {{ regionsService.getRegionName(region.id) }}
                  @if (authenticationService.getActiveRegionId() === region.id) {
                    <i class="ph ph-check"></i>
                  }
                </a>
              </li>
            }
            @if (authenticationService.getActiveRegion()?.educationUrl) {
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li>
                <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/education']" ngxMousetrapKey="e">
                  <i class="ph ph-graduation-cap"></i>
                  {{ "menu.education" | translate }}
                </a>
              </li>
            }
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              @if (authenticationService.isCurrentUserInRole("FORECASTER")) {
                <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/statistics']">
                  <i class="ph ph-chart-line"></i>
                  {{ "menu.statistics" | translate }}
                </a>
              }
            </li>
            <li>
              <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/settings']" ngxMousetrapKey="s">
                <i class="ph ph-gear"></i>
                {{ "menu.settings" | translate }}
              </a>
            </li>
            <li>
              @if (authenticationService.isCurrentUserInRole("ADMIN")) {
                <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/admin']" ngxMousetrapKey="a">
                  <i class="ph ph-detective"></i>
                  {{ "menu.admin" | translate }}
                </a>
              }
            </li>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              <a class="dropdown-item" href="#" routerLink="/pages/login" (click)="logout()" ngxMousetrapKey="l">
                <i class="ph ph-sign-out"></i>
                {{ "menu.logout" | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
}

<!-- Sidebar -->
<div class="sidebar" [class.sidebar--open]="isSidebarOpen" id="sidebarMenu">
  <div class="sidebar-content">
    @if (authenticationService.effectiveRole; as effectiveRole) {
      <p class="d-md-none" [title]="'settings.effectiveRole' | translate">
        <span class="badge" [class]="hasAdminPowers ? 'text-bg-danger' : 'text-bg-secondary'">
          {{ "role." + effectiveRole | translate }}
        </span>
      </p>
    }
    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      @if (authenticationService.isUserLoggedIn()) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/bulletins']">
            <i class="ph ph-snowflake"></i>
            {{ "sidebar.bulletins" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableDangerSources && authenticationService.isUserLoggedIn()) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/danger-sources']">
            <i class="ph ph-snowflake"></i>
            {{ "sidebar.dangerSources" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableObservations && authenticationService.isUserLoggedIn()) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/observations']">
            <i class="ph ph-eye"></i>
            {{ "sidebar.observations" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableIncidents && authenticationService.isUserLoggedIn()) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/incidents']">
            <i class="ph ph-eye"></i>
            {{ "sidebar.incidents" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableModelling && authenticationService.isUserLoggedIn()) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/modelling/geosphere']">
            <i class="ph ph-sphere"></i>
            {{ "sidebar.geosphere" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableIcon && authenticationService.isUserLoggedIn()) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/icon']">
            <i class="ph ph-image"></i>
            {{ "sidebar.icon" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableModelling) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/modelling/snowpack']" ngxMousetrapKey="g s">
            {{ "sidebar.snowpack" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableModelling) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/modelling/awsome']" ngxMousetrapKey="g a">
            {{ "sidebar.awsome" | translate }}
          </a>
        </li>
      }
      @if (authenticationService.getActiveRegion()?.enableLineaExport) {
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/graphics']">
            <i class="ph ph-chart-bar"></i>
            {{ "sidebar.graphics" | translate }}
          </a>
        </li>
      }
    </ul>
  </div>
</div>

<div class="app-body">
  <!-- Main content -->
  <main class="main">
    <!-- recreate the page on a role switch, as pages check the role only once on init -->
    @for (role of [authenticationService.effectiveRole]; track role) {
      <router-outlet></router-outlet>
    }
  </main>
</div>

<ng-template #changeRegionTemplate>
  <div class="modal-body text-center">
    <p>{{ "changeRegionDialog.message" | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="changeRegionModalConfirm()" ngxMousetrapKey="enter">
      {{ "changeRegionDialog.accept" | translate }}
    </button>
    <button type="button" class="btn btn-default" (click)="changeRegionModalDecline()">
      {{ "changeRegionDialog.reject" | translate }}
    </button>
  </div>
</ng-template>
